<template lang="pug">
	div
		menu-superior(:menu="menu")
		router-view
</template>

<script>
export default {
	data () {
		return {
			menu: [
				{
					url: '/main/panel-control/gestion-emisoras/emisoras',
					icono: 'fa fa-podcast',
					nombre: 'Emisoras'
				},
				{
					url: '/main/panel-control/gestion-emisoras/bloques',
					icono: 'fa fa-braille',
					nombre: 'Bloques'
				},
				{
					url: '/main/panel-control/gestion-emisoras/contenidos',
					icono: 'fa fa-cubes',
					nombre: 'Contenidos'
				},
				{
					url: '/main/panel-control/gestion-emisoras/programas',
					icono: 'fa fa-puzzle-piece',
					nombre: 'Programas'
				}
			]
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/index.vue